import Vue from 'vue'
import logger from '../helpers/logger.helper'

const STATUS_INITIAL = 0
const STATUS_IN_PROCESS = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3

class UploadService {
  constructor (options) {
    this.$logger = logger

    this.uploadedFiles = []
    this.queue = []
    this.inProgress = 0

    this.options = {
      fieldName: 'imageFiles[]',
      autostart: true,
      max_simultaneous_uploads: 1
    }

    options = options || {}
    this.options = Object.assign({}, this.options, options)
  }

  isInProgress () {
    return this.inProgress > 0
  }

  option = function (key, val) {
    let options = this.options || {}

    if (key && val) {
      this.options[key] = val
    } else if (key) {
      return options[key]
    }

    return options
  }

  onFileDone (file) {
    file.status = STATUS_SUCCESS
    this.$logger.log('filedone', file)
    this.inProgress--
    this.uploadNextFile()

    const callback = this.option('onFileDone')

    if (callback) {
      callback(file)
    }
  }

  onFileError (file) {
    file.status = STATUS_FAILED
    this.$logger.log('fileerror', file)
    this.inProgress--
    this.uploadNextFile()

    const callback = this.option('onFileError')

    if (callback) {
      callback(file)
    }
  }

  uploadNextFile () {
    this.$logger.log('uploadnextfile')
    if (!this.queue.length) {
      // empty queue
      this.$logger.log('empty queue')
      return
    }

    if (this.inProgress >= this.option('max_simultaneous_uploads')) {
      this.$logger.log('defer upload due to queue limit')
      return
    }

    this.uploadFile(this.queue.shift())
  }

  uploadFile (file) {
    this.inProgress++

    file.status = STATUS_IN_PROCESS

    const formData = new FormData()
    if (file.position != null) {
      formData.append('position', file.position)
    }
    formData.append(this.option('fieldName'), file.data, file.data.name)
    if (file.slot != null) {
      formData.append('slot', file.slot)
    }

    this.$logger.log('upload', file)
    return Vue.http.post(this.option('uploadUrl'), formData)
      // get data
      .then(response => response.data)
      .then(list => {
        return list.length ? list.pop() : {}
      })
      .then(uploadedFile => {
        file.uploaded = uploadedFile
        this.onFileDone(file)
        this.uploadedFiles.push(file)
      })
      .catch(err => {
        this.onFileError(file)
        this.$logger.log('failed', err)
      })
  }

  addFile (file) {
    file.status = STATUS_INITIAL
    this.queue.push(file)

    if (this.option('autostart')) {
      this.uploadNextFile()
    }
  }
}

const service = UploadService
export default service
